<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              v-show="haveBelink"
              color="#FF7F50"
              style="z-index: 8"
              id="v-step-0"
              depressed
              dark
              @click=";(dialogLinkBranch = true), pushFreeString()"
            >
              <v-icon left>mdi-link-variant</v-icon>
              ผูกสาขากับ Belink
            </v-btn>
            <v-btn
              color="#1B437C"
              style="z-index: 8"
              id="v-step-0"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่มสาขา
            </v-btn>
          </v-col>
          <!-- <v-col cols="6" class="v-margit_button text-right" >
            <v-btn
              color="#1B437C"
              style="z-index: 8"
              id="v-step-0"
              depressed
              dark
              @click=";(dialogLinkBranch = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              ผูกสาขากับ
            </v-btn>
          </v-col> -->
        </v-row>
        <v-row>
          <v-dialog v-model="dialogImport" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">จัดการไฟล์ผ่าน excel.xls</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <input type="file" @change="importData" accept=".xls" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table
                          :headers="columnsImport"
                          :items="dataItemImport"
                          :items-per-page="5"
                          class="elevation-1"
                        ></v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  color="red darken-1"
                  @click=";(dialogImport = false), (dataItemImport = [])"
                >
                  ปิด
                </v-btn>
                <template v-if="!dataItemImportChecKHide">
                  <v-btn
                    elevation="2"
                    color="red"
                    @click="importDataApprove('delete')"
                  >
                    ล้างข้อมูลทั้งหมดที่เลือก
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="blue darken-1"
                    @click="importDataApprove('update')"
                  >
                    ปรับปรุงข้อมูลที่ตรงกัน
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="green darken-1"
                    @click="importDataApprove('add')"
                  >
                    นำเข้าใหม่ทั้งหมด
                  </v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end Import -->

          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <!-- <v-card-text> -->
                <v-container>
                  <v-row style="padding-top:15px;padding-bottom:15px">
                    <v-col style="padding: 15px 16px 0px">
                      <h2>เพิ่มข้อมูลสาขา</h2>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="padding: 0px 16px">
                      <v-text-field
                        v-model="formAdd.masBranchName"
                        label="สาขา"
                        :rules="nameRules"
                        outlined
                        dense
                      ></v-text-field>
                      <v-text-field
                        v-model="formAdd.map"
                        label="แผนที่"
                        outlined
                        dense
                      ></v-text-field>
                      <v-text-field
                        v-model="formAdd.tel"
                        label="เบอร์โทรศัพท์"
                        placeholder="xxx-xxx-xxxx"
                        outlined
                        dense
                        v-mask="'###-###-####'"
                      ></v-text-field>
                      <v-text-field
                        v-model="formAdd.timeOC"
                        label="เวลาทำการ"
                        placeholder="08.00 - 17.00"
                        outlined
                        dense
                        v-mask="'##.## น.' + ' - ' + '##.## น.'"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
              <v-card-actions id="v-step-1">
                <v-btn
                  elevation="2"
                  large
                  dark
                  block
                  color="#173053"
                  :loading="loadingAdd"
                  @click="addData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่มข้อมูล
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEdit = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <!-- <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-img
                          class="v-img-margit"
                          :src="require('@/assets/GroupEditbranch.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" class="v-margit_text_add">
                        <v-img
                          class="v_text"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row> -->
                    <v-row>
                      <v-col style="padding: 16px 15px 20px 15px; text-align: left;">
                        <h2>แก้ไขข้อมูลสาขา</h2>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="formUpdate.masBranchCode"
                          label="รหัสสาขา*"
                          :rules="nameRules"
                          outlined
                          dense
                          readonly
                        ></v-text-field>
                        <v-text-field
                          v-model="formUpdate.masBranchName"
                          label="สาขา"
                          :rules="nameRules"
                          outlined
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-model="formUpdate.map"
                          label="แผนที่"
                          outlined
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-model="formUpdate.tel"
                          label="เบอร์โทรศัพท์"
                          placeholder="xxx-xxx-xxxx"
                          outlined
                          dense
                          v-mask="'###-###-####'"
                        ></v-text-field>
                        <v-text-field
                          v-model="formUpdate.timeOC"
                          label="เวลาทำการ"
                          placeholder="08.00 - 17.00"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions id="v-step-3">
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      :disabled="!validUpdate"
                      color="#173053"
                      :loading="loadingEdit"
                      @click="editData()"
                      dark
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- edit LINEConfigSendMessage -->
          <v-dialog v-model="dialogEditLineConfig" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right pb-1">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEditLineConfig = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col class="text-left pb-1 pt-1">
                      <div style="font-size: 20px;font-weight: 500;display:flex;margin-bottom: 20px">
                        <v-icon class="iconify mr-2" data-icon="icon-park-outline:setting-web"></v-icon>
                        <div style="border-bottom: solid 3px;">ตั้งค่า Line config</div>
                      </div>
                      <div style="font-size: 15px;display:flex"><div style="color:rgb(27, 67, 124);font-size:23px">**</div>สาขา {{formUpdate.masBranchName}}</div>
                    </v-col>
                    <v-container>
                      <v-stepper v-model="e1">
                        <v-stepper-header>
                          <v-stepper-step
                            :complete="e1 > 1"
                            step="1"
                          >
                            Messaging API
                          </v-stepper-step>

                          <v-divider></v-divider>

                          <v-stepper-step
                            :complete="e1 > 2"
                            step="2"
                          >
                            LINE Login
                          </v-stepper-step>
                        </v-stepper-header>

                        <v-stepper-items>
                          <v-stepper-content step="1" class="pa-2">
                            <v-card
                              class="mb-12"
                            >
                                <v-container>
                                  <v-card-text>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="formUpdate.messagingAPIChannelId"
                                          label="Channel ID"
                                          outlined
                                          dense
                                          prepend-inner-icon="mdi-lock"
                                          required
                                          :rules="[rules.required]"
                                        >
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="formUpdate.messagingAPIChannelSecret"
                                          label="Channel secret"
                                          outlined
                                          dense
                                          prepend-inner-icon="mdi-lock"
                                          required
                                          :rules="[rules.required]"
                                        >
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-container>
                            </v-card>
                            <div>
                              <v-btn
                              color="rgb(27, 67, 124)"
                              @click="checkMessaging()"
                              class="mb-2"
                              dark
                              block
                              >
                                ต่อไป
                                <v-icon class="iconify" color="white" data-icon="mi:next"></v-icon>
                              </v-btn>
                              </div>
                              <v-btn
                                color="warning"
                                @click="gotoManaul('messagingApi')"
                                style="font-size: 10px"
                                block
                              >
                                <v-icon
                                  left
                                  dark
                                >
                                  mdi-help-circle
                                </v-icon>
                                วิธีได้รับ Channel ID และ Channel secret (Messaging API)
                              </v-btn>
                          </v-stepper-content>

                          <v-stepper-content step="2">
                            <v-card
                              class="mb-12"
                            >
                                <v-container>
                                  <v-card-text>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="formUpdate.lineLoginChannelId"
                                          label="Channel ID"
                                          outlined
                                          dense
                                          prepend-inner-icon="mdi-lock"
                                          required
                                          :rules="[rules.required]"
                                        >
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="formUpdate.lineLoginChannelSecret"
                                          label="Channel secret"
                                          outlined
                                          dense
                                          prepend-inner-icon="mdi-lock"
                                          required
                                          :rules="[rules.required]"
                                        >
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-container>
                            </v-card>
                            <v-btn
                              color="error"
                              @click="e1 = 1"
                            >
                              ย้อนกลับ
                            </v-btn>

                            <v-btn
                              v-if="statusGetData === true"
                              color="primary"
                            @click="checkLineLogin()"
                            >
                              บันทึกข้อมูล
                            </v-btn>
                            <v-btn
                              v-if="statusGetData === false"
                              color="primary"
                            @click="checkLineLoginUpdate()"
                            >
                              แก้ไขข้อมูล
                            </v-btn>
                            <v-btn
                              color="warning"
                              @click="gotoManaul('lineLogin')"
                              style="font-size: 10px"
                              class="mt-2"
                            >
                              <v-icon
                                left
                                dark
                              >
                                mdi-help-circle
                              </v-icon>
                              วิธีได้รับ Channel ID และ Channel secret (LINE Login)
                            </v-btn>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                      <br>
                      <v-alert
                        border="top"
                        colored-border
                        type="info"
                        elevation="2"
                      >
                      เมื่อทำรายการสำเร็จกรุณาเปลี่ยนลิ้งบัตรสะสมคะแนนใน Rich Menu ตาม Line Oa แต่ละสาขา ของท่าน.
                      </v-alert>
                      <!-- <v-alert
                        border="bottom"
                        colored-border
                        type="warning"
                        elevation="2"
                        style="font-size: 14px"
                      >
                        เมื่อทำรายการสำเร็จกรุณาเปลี่ยนลิ้งค์นัดหมายใน Rich Menu หรือ โพสโปรโมทใน Social Media ของท่าน
                      </v-alert> -->
                    </v-container>
                  </v-container>
                </v-card-text>
              </v-form>
              <!-- <v-card-actions id="v-step-3">
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      :disabled="!validUpdate"
                      color="#173053"
                      :loading="loadingEdit"
                      @click="editData()"
                      dark
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions> -->
            </v-card>
          </v-dialog>
          <!-- edit LINEConfigSendMessage -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัสสาขา*"
                        v-model="formUpdate.masBranchCode"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                      <v-text-field
                        label="สาขา"
                        v-model="formUpdate.masBranchName"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->
          <v-dialog v-model="dialogLinkBranch" persistent max-width="500px">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-container>
                  <v-card-title>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2 style="margin-left: 5px;">ผูกสาขากับ Belink</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click=";(dialogLinkBranch = false), clearDataBranch()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" v-for="(item, i) in dataItem" :key="i" style="padding: 0px 16px">
                        <p><v-icon>mdi-store</v-icon> สาขาที่ {{i + 1}}</p>
                        <v-text-field
                          :value="item.masBranchName"
                          label="สาขา Loyalty"
                          outlined
                          readonly
                          hide-details
                          dense
                        ></v-text-field>
                        <div style="text-align: center;"><v-icon center>mdi-link-variant</v-icon></div>
                        <!-- {{vSelectBranchBelink[i]}} -->
                        <v-select
                          v-model="vSelectBranchBelink[i]"
                          :items="belinkBranch"
                          item-text="masBranchName"
                          clearable
                          @click:clear="remove(vSelectBranchBelink[i], item, i)"
                          item-value="masBranchID"
                          label="สาขา Belink"
                          dense
                          outlined
                          @change="pushDataBranchForUpdate(vSelectBranchBelink[i], item, i)"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <!-- <v-container fluid>
                    <v-row align="center">
                      <v-col cols="6">
                        <v-subheader>
                          Custom items
                        </v-subheader>
                      </v-col>

                      <v-col cols="6">
                        {{select[1]}}
                        <v-select
                          v-model="select[1]"
                          :items="items"
                          item-text="state"
                          item-value="abbr"
                          label="Select"
                          persistent-hint
                          return-object
                          single-line
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container> -->
                </v-container>
              </v-form>
              <v-card-actions style="position: sticky;bottom: 0;background-color: white;border-radius: 0px;">
                <v-btn
                  elevation="2"
                  large
                  dark
                  block
                  color="green"
                  :loading="loadingLinkBranch"
                  @click="updateBranchBelink()"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  บันทึกข้อมูล
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- data table -->
          <v-col cols="12">
            <v-alert
              dense
              type="info"
              v-if="showAlert"
            >
              หลังจากตั้งค่า Line Oa ตามสาขาเสร็จ สามารถไปเอาลิ้งได้ที่ >> <a style="text-decoration: underline" href="/System/link"> เมนูลิ้ง </a>
            </v-alert>
            <v-card elevation="4" v-if="dataReady">
              <!-- <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title> -->
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  disable-sort
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          id="v-step-2"
                          small
                          @click.stop="
                            ;(dialogEdit = true),
                              getDataById(item),
                              validate('UPDATE')
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="white"
                          fab
                          dark
                          id="v-step-2"
                          small
                          @click.stop="
                            checkLiff(item),
                              getDataById(item),
                              validate('UPDATE')
                          "
                        >
                          <v-icon class="iconify" color="green" data-icon="fa-brands:line"></v-icon>
                        </v-btn>
                      </template>
                      <span>ตั้งค่าLine Oa</span>
                    </v-tooltip> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          small
                          @click.stop="
                            ;(dialogDelete = true), getDataById(item)
                          "
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'

// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      dialogEditLineConfig: false,
      accessToken: '',
      showAlert: null,
      statusGetData: true,
      e1: 1,
      events: ['click', 'mousemove', 'mousedown', 'keypress'],
      warningTime: null,
      logOutTimer: null,
      belink: false,
      PK: '',
      path: '/master_branch/', // Path Model
      returnLink: '/Master/Branch',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'สาขา',
          disabled: false,
          href: '/Master/Branch'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'BCH_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogLinkBranch: false,
      belinkBranch: null,
      haveBelink: null,
      vSelectBranchBelink: [],
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        masBranchCode: '',
        masBranchName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        masBranchCode: '',
        masBranchName: '',
        tel: '',
        map: '',
        timeOC: '',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        masBranchCode: '',
        masBranchName: '',
        tel: '',
        map: '',
        timeOC: '',
        messagingAPIChannelId: '',
        messagingAPIChannelSecret: '',
        lineLoginChannelId: '',
        lineLoginChannelSecret: '',
        shopId: ''
      },
      formUpdateItem: {
        masBranchCode: '',
        masBranchName: '',
        tel: '',
        map: '',
        timeOC: '',
        shopId: ''
      },
      nameRules: [
        v => !!v || 'กรุณากรอก',
        v => v.length <= 50 || 'Name must be less than 50 characters'
      ],
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รหัส สาขา', value: 'masBranchCode' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'เบอร์โทรศัพท์', value: 'tel' },
        { text: 'แผนที่', value: 'map', width: '300' },
        { text: 'เวลาทำการ', value: 'timeOC' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'masBranchID', value: 'masBranchID' },
        { text: 'masBranchCode', value: 'masBranchCode' },
        { text: 'masBranchName', value: 'masBranchName' },
        // { text: 'masCompanyCode', value: 'masCompanyCode' },
        { text: 'masCompanyName', value: 'masCompanyName' }
      ],
      select: [{ state: 'Florida', abbr: 'FL' }, { state: 'THailand', abbr: 'TH' }],
      items: [
        { state: 'Florida', abbr: 'FL' },
        { state: 'Georgia', abbr: 'GA' },
        { state: 'Nebraska', abbr: 'NE' },
        { state: 'California', abbr: 'CA' },
        { state: 'New York', abbr: 'NY' },
        { state: 'THailand', abbr: 'TH' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'Master-Branch.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        masBranchID: 'masBranchID',
        masBranchCode: 'masBranchCode',
        masBranchName: 'masBranchName',
        // masCompanyCode: 'masCompanyCode',
        masCompanyName: 'masCompanyName'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      Company: [],
      validUpdate: true,
      validAdd: true,
      //   loading
      loadingAdd: false,
      loadingEdit: false,
      loadingLinkBranch: false,
      formUpdateBranch: []
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    // this.$tours['myTour'].start()
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    if (this.$route.query.tour) {
      if (this.$route.query.tour === 'true') {
        this.$tours['myTour'].start()
      } else {
        this.$tours['myTourPage'].start()
      }
    }
    this.events.forEach(Event => {
      window.addEventListener(Event, this.resetTime)
    })
    await this.checkBelink()
    console.log('dataItem2222', this.dataItem)
    let foundItem = this.dataItem.find(item => item.liffMainIDLoyalty !== '' && item.liffMainIDLoyalty !== null)
    if (foundItem) {
      this.showAlert = true
    } else {
      this.showAlert = false
    }
    // this.pushDataBranchForUpdate()
    // if (this.session.data.shopId === 'undefined') {
    //   this.$router.push('/Core/Login')
    // }
    // if (this.$session.exists()) {
    //   this.$router.push('/Core/Login')
    // }
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    checkLiff (item) {
      console.log(item)
      if (item.liffMainIDLoyalty !== null && item.liffMainIDLoyalty !== 'None' && item.liffMainIDLoyalty !== '') {
        alert('ตั้งค่าแล้ว')
      } else {
        this.dialogEditLineConfig = true
      }
    },
    async getDataById (item) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      // this.getDataByIdGlobal(
      //   this.DNS_IP,
      //   this.path,
      //   'masBranchID',
      //   item.masBranchID,
      //   this.returnLink
      // )
      await axios.get(this.DNS_IP + '/master_branch/get?masBranchID=' + item.masBranchID).then((response) => {
        let rs = response.data[0]
        this.formUpdate = rs
        this.dataReady = true
      })
      console.log('ccc', this.formUpdate)
      if (!this.formUpdate.liffMainIDLoyalty) {
        this.statusGetData = true
      } else {
        this.statusGetData = false
      }
    },
    async addData () {
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName

      console.log('form', JSON.stringify(this.formAdd))

      this.formAdd.masBranchCode = this.code + this.generateCodeGlobal()

      this.dataReady = false
      if (this.formAdd.masBranchName === '') {
        this.$swal('ผิดพลาด', 'กรอกชื่อ แผนก', 'error')
      } else if (this.formAdd.masBranchCode === '') {
        this.$swal('ผิดพลาด', 'กรุณาเลือก สาขา', 'error')
      } else {
        this.dataReady = false
        this.submitAdd()
      }
    },
    async submitAdd () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'add',
              this.formAdd,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.clearData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // Config User ทำรายการล่าสุด
      this.formUpdateItem.LAST_USER = this.$session.getAll().data.userName
      // End Config User ทำรายการล่าสุด

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }
      console.log('this.formUpdateItem', this.formUpdate)
      this.dataReady = false
      this.submitEdit(this.DNS_IP, this.path, this.formUpdate.masBranchID, this.formUpdateItem)
    },
    async submitEdit (DNS_IP, PATH, ID, DT) {
      this.dataReady = false
      // alert(ID)
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + 'edit/' + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              await this.getDataGlobal(
                DNS_IP,
                PATH,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async checkLineLogin () {
      if (this.formUpdate.lineLoginChannelId !== '' && this.formUpdate.lineLoginChannelSecret !== '') {
        this.dataReady = false
        let dt = {
          'lineLoginChannelId': this.formUpdate.lineLoginChannelId,
          'lineLoginChannelSecret': this.formUpdate.lineLoginChannelSecret,
          'messagingAPIChannelId': this.formUpdate.messagingAPIChannelId,
          'messagingAPIChannelSecret': this.formUpdate.messagingAPIChannelSecret,
          'masBranchID': this.formUpdate.masBranchID,
          'shopId': this.$session.getAll().data.shopId,
          'CREATE_USER': this.$session.getAll().data.userName,
          'LAST_USER': this.$session.getAll().data.userName
        }
        console.log(dt)
        await axios
          .post(this.DNS_IP + '/line/createLiff', dt)
          .then(async response => {
            console.log(response.data)
            let rs = response.data
            // alert(rs)
            if (rs.status === true) {
              this.e1 = 1
              this.$swal('เรียบร้อย', 'ตั้งค่า Line Oa เรียบร้อย', 'success')
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              if (this.$route.query.tour) {
                if (this.$route.query.tour === 'true') {
                  this.$tours['myTour'].start()
                } else {
                  this.$tours['myTourPage'].start()
                }
              }
              this.events.forEach(Event => {
                window.addEventListener(Event, this.resetTime)
              })
              await this.checkBelink()
              console.log('dataItem2222', this.dataItem)
              let foundItem = this.dataItem.find(item => item.liffMainIDLoyalty !== '' && item.liffMainIDLoyalty !== null)
              if (foundItem) {
                this.showAlert = true
              } else {
                this.showAlert = false
              }
              this.dataReady = true
              this.dialogEditLineConfig = false
            } else {
              this.e1 = 2
              this.dataReady = true
              this.$swal('ผิดพลาด', 'กรุณาตรวจสอบ Channel ID และ Channel secret ของ LINE Login', 'error')
            }
          }).catch(error => {
            console.log(error)
            this.$swal('ผิดพลาด', 'กรุณาตรวจสอบ Channel ID และ Channel secret ของLINE Login', 'error')
            this.dataReady = true
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณากรอก Channel ID และ Channel secret ของ LINE Login ให้ครบ', 'error')
        this.dataReady = true
      }
    },
    async checkLineLoginUpdate () {
      if (this.formUpdate.lineLoginChannelId !== '' && this.formUpdate.lineLoginChannelSecret !== '') {
        this.dataReady = false
        let dt = {
          'lineLoginChannelId': this.formUpdate.lineLoginChannelId,
          'lineLoginChannelSecret': this.formUpdate.lineLoginChannelSecret,
          'messagingAPIChannelId': this.formUpdate.messagingAPIChannelId,
          'messagingAPIChannelSecret': this.formUpdate.messagingAPIChannelSecret,
          'shopId': this.$session.getAll().data.shopId,
          'LAST_USER': this.$session.getAll().data.userName
        }
        await axios
          .post(this.DNS_IP + '/line/createLiff', dt)
          .then(async response => {
            let rs = response.data
            if (rs.status === true) {
              this.e1 = 1
              this.$swal('เรียบร้อย', 'เปิดใช้งานระบบแจ้งเตือนอัตโนมัติเรียบร้อย', 'success')
              this.dataReady = true
              this.dialogEditLineConfig = false
            } else {
              this.e1 = 2
              this.dataReady = true
              this.$swal('ผิดพลาด', 'กรุณาตรวจสอบ Channel ID และ Channel secret ของ LINE Login', 'error')
            }
          }).catch(error => {
            console.log(error)
            this.$swal('ผิดพลาด', 'กรุณาตรวจสอบ Channel ID และ Channel secret ของLINE Login', 'error')
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณากรอก Channel ID และ Channel secret ของ LINE Login ให้ครบ', 'error')
        this.dataReady = true
      }
    },
    async deleteData () {
      console.log('DELETE PK : ', this.PK)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.masBranchID,
        this.$session.getAll().data.shopId,
        '',
        this.returnLink
      )
    },
    async checkMessaging () {
      if (this.formUpdate.messagingAPIChannelId !== '' && this.formUpdate.messagingAPIChannelSecret !== '') {
        this.dataReady = false
        await axios
          .post(this.DNS_IP + '/line/checkMessagingAPI', {'messagingAPIChannelId': this.formUpdate.messagingAPIChannelId, 'messagingAPIChannelSecret': this.formUpdate.messagingAPIChannelSecret})
          .then(async response => {
            let rs = response.data
            if (rs.status === true) {
              this.e1 = 2
              this.accessToken = rs.accessToken
              this.dataReady = true
            } else {
              this.e1 = 1
              this.accessToken = ''
              this.$swal('ผิดพลาด', 'กรุณาตรวจสอบ Channel ID และ Channel secret ของ Messaging API', 'error')
              this.dataReady = true
            }
          }).catch(error => {
            console.log(error)
            this.$swal('ผิดพลาด', 'กรุณาตรวจสอบ Channel ID และ Channel secret ของ Messaging API', 'error')
            this.dataReady = true
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณากรอก Channel ID และ Channel secret ของ Messaging API ให้ครบ', 'error')
        this.dataReady = true
      }
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?masBranchCode=' +
        this.searchAll +
        '&masBranchName=' +
        this.searchAll +
        '&masCompanyName=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search)
    },
    async saerchDataAdvanced () {
      var search = ''
      var check = false
      // config วันที่สร้าง วันที่แก้ไข
      // config นำวันที่สิ้นสุดมาต่อ 23:59:59
      if (
        this.search.create_date_start !== '' &&
        this.search.create_date_end === ''
      ) {
        this.search.create_date_end =
          this.search.create_date_start + ' 23:59:59'
      } else {
        if (this.search.create_date_start !== '') {
          this.search.create_date_end =
            this.search.create_date_end + ' 23:59:59'
        }
      }

      if (
        this.search.last_date_start !== '' &&
        this.search.last_date_end === ''
      ) {
        this.search.last_date_end = this.search.last_date_start + ' 23:59:59'
      } else {
        if (this.search.last_date_end !== '') {
          this.search.last_date_end = this.search.last_date_end + ' 23:59:59'
        }
      }
      for (var key in this.search) {
        check = true
        if (this.search[key]) {
          if (search !== '') {
            search += '&'
          }
          search += key + '=' + this.search[key]
        }

        if (
          this.search.last_date_start === '' &&
          this.search.last_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่แก้ไข เริ่มต้น', 'error')
        }

        if (
          this.search.create_date_start === '' &&
          this.search.create_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่สร้าง เริ่มต้น', 'error')
        }
      }
      console.log('saerchDataAdvanced', search)
      //
      //
      // สำหรับ ค้นหาแบบ กำหนดจาก form serach
      //
      if (check === true) {
        this.dataReady = false

        this.saerchDataAdvancedGlobal(this.DNS_IP, this.path, search)
      } else {
        this.dataReady = true
      }
    },
    async clearData () {
      this.formAdd.masBranchCode = ''
      this.formAdd.masBranchName = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.timeOC = ''
      this.formAdd.map = ''
      this.formAdd.tel = ''
      this.e1 = 1
    },
    importData (event) {
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach(sheetName => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          console.log(rowObj)
          this.dataItemImport = rowObj
        })
        if (this.dataItemImport.length === 0) {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง')
        } else {
          this.dataItemImportChecKHide = false
        }
      }

      reader.readAsBinaryString(input.files[0])
    },
    importDataApprove (action) {
      console.log('Action', action)
      var titleMsg = ''
      var checkError = false
      if (action === 'add') {
        titleMsg = 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else if (action === 'delete') {
        titleMsg = 'ท่านต้องการ ลบข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else {
        titleMsg = 'ท่านต้องการ ปรับปรุงข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      }

      this.$swal({
        title: titleMsg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          for (var key in this.dataItemImport) {
            this.PK = this.dataItemImport[key].masBranchID
            if (action === 'add') {
              console.log('add')
              await this.importDataAdd(this.dataItemImport[key])
              checkError = true
            } else {
              await axios
                .get(
                  // eslint-disable-next-line quotes
                  this.DNS_IP +
                    this.path +
                    'get?masBranchID=' +
                    this.dataItemImport[key].masBranchID,
                  {
                    headers: {
                      'Application-Key': this.$session.getAll().ApplicationKey
                    }
                  }
                )
                .then(async response => {
                  if (action === 'update') {
                    await this.importDataUpdate(this.dataItemImport[key])
                    checkError = true
                  }
                  if (action === 'delete') {
                    await this.importDataDelete(this.dataItemImport[key])
                    checkError = true
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  checkError = false

                  console.log('error /master_branch/get?masBranchID : ', error)
                })
            }
          }
          console.log(checkError)
          if (checkError === true) {
            await this.getDataGlobal(
              this.DNS_IP,
              this.path,
              this.session.data.shopId
            )
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          }
        })
        .catch(error => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = true
        })
    },
    async importDataAdd (dt) {
      Object.assign(this.formAdd, dt)
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName

      delete this.formAdd['masBranchID']
      delete this.formAdd['LAST_DATE']
      delete this.formAdd['CREATE_DATE']
      delete this.formAdd['RECORD_STATUS']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'add',
          this.formAdd,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dialogImport = false
          // Debug response
          console.log('/master_branch/add/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataAdd addData : ', error)
          this.dataReady = true
        })
    },
    async importDataUpdate (dt) {
      Object.assign(this.formUpdate, dt)
      delete this.formUpdate['masBranchID']
      delete this.formUpdate['LAST_DATE']
      delete this.formUpdate['CREATE_DATE']
      delete this.formUpdate['RECORD_STATUS']
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }

      // Debug
      console.log('EDIT PK : ', this.PK)
      console.log('formUpdateItem', JSON.stringify(this.formUpdateItem))

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'edit/' + dt.masBranchID,
          this.formUpdateItem,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dialogImport = false
          // Debug response
          console.log('/master_branch/edit/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataUpdate : ', error)
        })
    },
    async importDataDelete (dt) {
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'delete/' + dt.masBranchID,
          this.formUpdate,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dialogImport = false
          // Debug response
          console.log('/master_branch/delete/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataDelete : ', error)
        })
    },
    async getBranchBelink () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IPBelink + '/master_branch/get?shopId=' + this.$session.getAll().data.shopId
        )
        .then(async response => {
          console.log('belinkBranch', response)
          this.belinkBranch = response.data
          console.log('this.belinkBranch', this.belinkBranch)
          // this.belinkBranch
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function getBranchBelink : ', error)
        })
    },
    async checkBelink () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IPBelink + '/sys_shop/get?shopId=' + this.$session.getAll().data.shopId
        )
        .then(async response => {
          console.log('checkBelink', response.data.length)
          if (response.data.length > 0) {
            this.haveBelink = true
            // await this.getBranchBelink()
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function checkBelink : ', error)
        })
    },
    async updateBranchBelink () {
      // let formUpdateBranch = [{'id': '59', 'branchId': '10'}, {'id': '56', 'branchId': '100'}]
      this.loadingLinkBranch = true
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/linkBelink_master_branch/multi_edit', this.formUpdateBranch
        )
        .then(async response => {
          console.log('updateBranchBelink', response)
          if (response.status) {
            // this.dialogLinkBranch = false
            this.loadingLinkBranch = false
            this.$swal('เรียบร้อย', 'ผูกสาขาเรียบร้อย เรียบร้อย', 'success')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function updateBranchBelink : ', error)
        })
      console.log('this.belinkBranch', this.belinkBranch)
      console.log('this.formUpdateBranch', this.formUpdateBranch)
      console.log('this.vSelectBranchBelink', this.vSelectBranchBelink)
    },
    pushDataBranchForUpdate (item, item2, index) {
      console.log('pushDataBranchForUpdate', item)
      console.log('pushDataBranchForUpdate', item2)
      console.log('pushDataBranchForUpdate', index)
      if (item !== null) {
        this.formUpdateBranch.map((item3, index) => {
          if (item3.id === item2.masBranchID) {
            this.formUpdateBranch[index].branchId = item
          }
          console.log(item3.id)
        })
        this.belinkBranch.map((a) => {
          if (a.masBranchID === item) {
            a.disabled = true
            a.masBranchName = a.masBranchName + '   (เลือกแล้ว)'
          }
        })
      }

      // }
      // this.formUpdateBranch
      // this.dataItem.map((a) => {
      // })
    },
    async pushFreeString () {
      await this.getDataGlobal(
        this.DNS_IP,
        this.path,
        this.session.data.shopId,
        this.returnLink
      )
      await this.getBranchBelink()
      console.log(this.dataItem)
      console.log(this.belinkBranch)
      this.dataItem.forEach(item => this.vSelectBranchBelink.push(null))
      this.dataItem.forEach((item) => {
        let dt = {'id': item.masBranchID, 'branchId': item.branchId}
        this.formUpdateBranch.push(dt)
      })
      console.log('this.formUpdateBranch', this.formUpdateBranch)
      this.dataItem.forEach((a, i) => {
        this.belinkBranch.forEach((b, index) => {
          // console.log(a.branchId)
          // console.log(b.masBranchID)
          // console.log(i)
          if (parseInt(a.branchId) === parseInt(b.masBranchID)) {
            this.vSelectBranchBelink[i] = { masBranchID: b.masBranchID, masBranchName: b.masBranchName }
            this.belinkBranch[index].disabled = true
            this.belinkBranch[index].masBranchName = this.belinkBranch[index].masBranchName + '   (เลือกแล้ว)'
          }
        })
      })
      console.log('vSelectBranchBelink', this.vSelectBranchBelink)
    },
    remove (item, item2, index) {
      console.log('dddd', item)
      console.log('dddd', item2)
      console.log('dddd', index)
      if (typeof item === 'object') {
        this.belinkBranch.map((a) => {
          if (parseInt(a.masBranchID) === parseInt(item.masBranchID)) {
            a.disabled = false
            a.masBranchName = a.masBranchName.split('   ')[0]
            console.log(a.masBranchID)
          }
        })
        this.formUpdateBranch.map((a, i) => {
          if (item.masBranchID === parseInt(a.branchId)) {
            this.formUpdateBranch[i].branchId = null
          }
        })
      } else {
        this.belinkBranch.map((a) => {
          if (a.masBranchID === item) {
            a.disabled = false
            a.masBranchName = a.masBranchName.split('   ')[0]
            console.log(a.masBranchID)
          }
        })
        this.formUpdateBranch.map((a, i) => {
          if (item === parseInt(a.branchId)) {
            this.formUpdateBranch[i].branchId = null
          }
        })
      // this.formUpdateBranch = this.formUpdateBranch.filter(a => item !== a.branchId)
      }

      console.log('this.formUpdateBranch2222', this.belinkBranch)
      console.log('this.formUpdateBranch2222', this.formUpdateBranch)
    },
    clearDataBranch () {
      this.vSelectBranchBelink = []
      this.belinkBranch = []
      this.formUpdateBranch = []
      // console.log(vSelectBranchBelink)
    }
  }
}
</script>
<style scoped>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
#subtext {
  color: #173053;
  font-size: 25px !important;
  font-weight: bold;
}
#margin {
  margin-top: 30px;
  margin-bottom: 70px;
}
.v-text-field {
  padding: 0px 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Branch.vue